export default __webpack_public_path__ + "assets/images/73d0803d5250a4b864e457582f071f7e.svg";